import type { Landmark } from '../data/types';
import type { Ring, Vec2 } from '../geo/types';
import { pointInRing } from '../geo/polygon';
import { dominantAxis, planBounds, planFrameOf } from '../world/fabric/landmarks/planFrame';

/** Shared by the masonry, the walker and the market standing on the dam. */
export const DAM_DECK = { crestY: 3.6 } as const;

export function damDeckProfile(landmark: Landmark) {
  const plan = planFrameOf(landmark.footprint, dominantAxis(landmark.footprint, landmark.heading));
  const rect = planBounds(plan);
  return { plan, ...rect };
}

/** The Dam is level with the city and canal-wall tops, including both bank approaches. */
export function damDeckHeight(landmark: Landmark, p: Vec2): number | null {
  return pointInRing(p, landmark.footprint) ? DAM_DECK.crestY : null;
}

export function damDeckFootprints(landmarks: readonly Landmark[]): readonly Ring[] {
  return landmarks.filter((l) => l.kind === 'dam').map((l) => l.footprint);
}
